// 环境配置
const is_dev = import.meta.env.MODE === 'development'

// API 基础地址
export const API_BASE_URL = is_dev ? 'http://127.0.0.1:8080' : 'https://sysapi.tianchang56.com'

// API 路径前缀
export const API_PATH = '/api/v1'
